module.exports = __webpack_public_path__ + "b5ee2ea2cbc7ea5cc16e3e7b500c097b.svg";